import { useCallback } from 'react'
import { Navigate, useNavigate, useSearch } from '@tanstack/react-router'
import { RecuperaAiScreen } from '@features/recupera-ai'
import type { RecuperaAiSearch } from '@features/recupera-ai'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'

export function RecuperaAiPage() {
  const recuperaAiEnabled = useFeatureFlag('recuperaAi')
  const search = useSearch({ from: '/protected/recupera-ai' })
  const navigate = useNavigate()

  const onSearchChange = useCallback(
    (next: RecuperaAiSearch) => {
      void navigate({ to: '/recupera-ai', search: next, replace: true })
    },
    [navigate],
  )

  if (!recuperaAiEnabled) {
    return <Navigate to="/" replace />
  }

  return <RecuperaAiScreen search={search} onSearchChange={onSearchChange} />
}
